import { render, staticRenderFns } from "./single_detail.vue?vue&type=template&id=6efca82c&scoped=true"
import script from "./single_detail.vue?vue&type=script&lang=js"
export * from "./single_detail.vue?vue&type=script&lang=js"
import style0 from "./single_detail.vue?vue&type=style&index=0&id=6efca82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efca82c",
  null
  
)

export default component.exports